import { 
  FaReact, 
  FaNodeJs, 
  FaDocker, 
  FaGithub, 
  FaPython,
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaGitAlt,
  FaLinux,
  FaFigma,
  FaTools,
  FaCode
} from 'react-icons/fa';
import { 
  SiTypescript,
  SiCplusplus,
  SiGo,
  SiMysql,
  SiUbuntu,
  SiPrometheus,
  SiFirebase,
  SiGithubcopilot,
  SiGooglegemini,
  SiOpenai,
  SiUnity
} from 'react-icons/si';
import { TbBrandCSharp } from "react-icons/tb";

export const skillCategories = [
  {
    category: "Frontend",
    skills: [
      { name: "React", icon: FaReact },
      { name: "JavaScript", icon: FaJs },
      { name: "TypeScript", icon: SiTypescript },
      { name: "HTML5", icon: FaHtml5 },
      { name: "CSS3", icon: FaCss3Alt }
    ]
  },
  {
    category: "Backend/APIs",
    skills: [
      { name: "Go", icon: SiGo },
      { name: "Python", icon: FaPython },
      { name: "Node.js", icon: FaNodeJs },
      { name: "C#", icon: TbBrandCSharp },
      { name: "C++", icon: SiCplusplus },
      { name: "gRPC", icon: FaCode },
      { name: "MySQL", icon: SiMysql },
      { name: "Firebase", icon: SiFirebase }
    ]
  },
  {
    category: "Tools & DevOps",
    skills: [
      { name: "Linux", icon: FaLinux },
      { name: "Ubuntu", icon: SiUbuntu },
      { name: "Docker", icon: FaDocker },
      { name: "Git", icon: FaGitAlt },
      { name: "GitHub", icon: FaGithub },
      { name: "Keycloak", icon: FaTools },
      { name: "Prometheus", icon: SiPrometheus }
    ]
  },
  {
    category: "Other",
    skills: [
      { name: "Unity", icon: SiUnity },
      { name: "VS Code", icon: FaCode },
      { name: "Figma", icon: FaFigma },
      { name: "LaTeX", icon: FaCode }
    ]
  },
  {
    category: "AI Stack",
    skills: [
      { name: "GitHub Copilot", icon: SiGithubcopilot },
      { name: "Gemini", icon: SiGooglegemini },
      { name: "ChatGPT", icon: SiOpenai }
    ]
  }
];

// Legacy export for compatibility (optional - can be removed if not used elsewhere)
export const skills = skillCategories.flatMap(cat => cat.skills);
